import React, { useState } from 'react';
import './style.scss';

import Btn from "../../../Btn";
import PropTypes from "prop-types";

export const ConfirmCandidate = ({ onClose, onConfirm, data, errorConfirmVote }) => {

    const [confirm, setConfirm] = useState(false);

    const handleConfirm = () => {
        setConfirm(true);
        onConfirm();
    };

    const renderIsSure = () => {
        return (
            <div className = 'confirm-cand__child'>
                <h3 className = 'confirm-cand__title'>Ви впевнені, що хочете віддати свій голос за </h3>
                {
                    data?.candidate?.title ?
                        <div className = 'confirm-cand__name-wrap'>
                            <span className = 'confirm-cand__name'>{data.candidate.title}</span>
                        </div>
                        :
                        null
                }
                <div className = 'confirm-cand__btns'>
                    <Btn
                        full
                        theme = 'black'
                        title = 'Так'
                        onPress = { handleConfirm }
                    />
                    <Btn
                        full
                        theme = 'transp-black'
                        title = 'Ні'
                        onPress = { onClose }
                    />
                </div>
            </div>
        );
    };

    const renderResult = () => {
        return (
            <div className = 'confirm-cand__child'>
                <div className = 'confirm-cand__icon-wrap'>
                    {errorConfirmVote ?
                        <i className = { `icon icon-error_square` } />
                        :
                        <i className = { `icon icon-check_squareN` } />
                    }
                </div>
                <h3 className = 'confirm-cand__title'>
                    {errorConfirmVote ? "Помилка!" :
                        (<> Дякуємо, <br /> голос зарахований! </>)
                    }
                </h3>
                {errorConfirmVote ?
                    <p className = 'confirm-cand__desription'>Ваш голос не зарахований, повторіть спробу через деякий час!</p>
                    :
                    null
                }
                <div className = 'confirm-cand__btns'>
                    <Btn
                        full
                        theme = 'black'
                        title = 'ОК'
                        onPress = { onClose }
                    />
                </div>
            </div>
        );
    };

    return (

        <div className = 'confirm-cand'>
            {
                confirm ?
                    renderResult()
                    :
                    renderIsSure()
            }
        </div>

    );
};

ConfirmCandidate.propTypes = {
    onClose:          PropTypes.func.isRequired,
    onConfirm:        PropTypes.func.isRequired,
    data:             PropTypes.object,
    errorConfirmVote: PropTypes.bool,
};
